import PropTypes from "prop-types"
import styled from "styled-components"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"

import { specialSymbols } from "../common/constants"

const OrderRelatedInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  grid-column-gap: ${({ theme }) => theme.sizes.gapXSmall}px;
  color: ${({ theme }) => theme.colors.gray[700]};
  font-family: ${({ theme }) => theme.fontFamily.geberitRg};
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 1.25;
`

const OrderRelatedInfo = ({ hasOrderRelatedNote, hasMakeToOrderNote }) => {
  const { t } = useBrandedTranslation()
  return (
    <OrderRelatedInfoWrapper>
      {hasOrderRelatedNote && (
        <>
          <span>{specialSymbols.ASTERISK}</span>
          <span>{t("pdp-article-produce-on-order-text")}</span>
        </>
      )}
      {hasMakeToOrderNote && (
        <>
          <span>{specialSymbols.ASTERISK.repeat(2)}</span>
          <span>{t("pdp-article-produce-on-order-text-week")}</span>
        </>
      )}
    </OrderRelatedInfoWrapper>
  )
}

export default OrderRelatedInfo

OrderRelatedInfo.propTypes = {
  hasOrderRelatedNote: PropTypes.bool,
  hasMakeToOrderNote: PropTypes.bool,
}
